export interface Template {
  id: string;
  name: string;
  description: string;
  icon: string;
  template: object;
  urlSlug: string;
}

export const sidebarTemplates = [
  'com.atlassian.confluence.plugins.confluence-business-blueprints:business-strategy-blueprint',
  'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
  'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint',
  'com.atlassian.confluence.plugins.confluence-business-blueprints:vision-to-values-blueprint',
  'com.atlassian.confluence.plugins.confluence-business-blueprints:brainstorming-with-remote-teams-blueprint',
  'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-blueprint',
  'com.atlassian.confluence.plugins.confluence-business-blueprints:annual-plan-one-pager-blueprint',
  'com.atlassian.confluence.plugins.confluence-business-blueprints:product-roadmap-blueprint',
  'com.atlassian.confluence.plugins.confluence-business-blueprints:smart-goals-blueprint',
  'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-blueprint',
  'com.atlassian.confluence.plugins.confluence-business-blueprints:competitive-analysis-blueprint'
];
